import { Route } from 'react-router-dom';
import Error from './Error';

const NotFound = () => (
	// eslint-disable-next-line react/jsx-no-bind
	<Route render={({ staticContext, match }) => {
		if (staticContext) {
			staticContext.status = 404;
		}
		return <Error code={404} url={match.url} />;
	}}
	/>
);

export default NotFound;


// WEBPACK FOOTER //
// ./components/NotFound.js